'use strict'

_ = require('underscore')

TTD_CATEGORIES = ['things-to-do', 'fun-and-leisure-activities', 'kids-activities', 'nightlife', 'sightseeing-and-tours', 'sports-and-outdoor-activities', 'tickets-and-events']
TRENDING_RAPI_FILTER = 'data-embed-rapi-filter="badge_type:trending"'
CardUI = require 'grpn-card-ui/frontend/init'
{isFeatureEnabled, checkSetting} = require '../helpers/finch'
isScrolledToElement = require '../helpers/is_scrolled_to_element'
{getParameterByName} = require '../helpers/query_params'

module.exports = class WidgetView extends Backbone.View
  initialize: (options) ->
    @options = options
    @listenTo @model, 'sync', @_handleBottomWidgetResponse
    @load()

  load: ->
    @model.fetch
      data:
        _csrf: @options._csrf
        _hasShownRVD: !!@options._hasShownRVD
        _isSearchPage: @_isSearchPage()

  render: (widgetHtml) ->
    @$el.html(widgetHtml)
    CardUI.init('#pull-widget')

  _isSearchPage: ->
    getParameterByName('query') != null

  _isInUS: ->
    window.Groupon.division?.country is 'USA'

  _isTTDCategory: ->
    {category} = window.Groupon.Utils.unparam()
    _.contains(TTD_CATEGORIES, category)

  _shouldRenderTopRatedWidget: ->
    @_isInUS() and isFeatureEnabled('showTopRatedCarousel') and @_isTTDCategory()

  _shouldRenderBCookieRVDWidget: ->
    checkSetting('showBCookieBottomRVDDesktop')

  _handleBottomWidgetResponse: ->
    {bottomWidgetHtml, topRatedWidgetHtml, bCookieRVDWidgetHtml} = @model.toJSON()
    isTrendingDealsWidget = bottomWidgetHtml?.includes(TRENDING_RAPI_FILTER)
    isBCookieRVDWidget = bCookieRVDWidgetHtml?

    if topRatedWidgetHtml
      if @_shouldRenderTopRatedWidget() then @render(topRatedWidgetHtml)
    else if isBCookieRVDWidget and isTrendingDealsWidget
      @_addBottomWidgetScrollListener('showBCookieBottomRVDDesktop')
      if @_shouldRenderBCookieRVDWidget()
        @render(bCookieRVDWidgetHtml)
      else
        @render(bottomWidgetHtml)
    else if bottomWidgetHtml
      @render(bottomWidgetHtml)
      @_handleRVDWidgetViewAllLink() if not isTrendingDealsWidget

  _handleRVDWidgetViewAllLink: ->
    @_addBottomWidgetScrollListener('showLinkOnRvdDesktop')
    if not checkSetting('showLinkOnRvdDesktop')
      document.querySelector('#pull-widget .cui-title a')?.style?.display = 'none'

  _addBottomWidgetScrollListener: (featureKey) ->
    if isScrolledToElement(@el)
      isFeatureEnabled(featureKey)
    else
      @_handleBottomWidgetBucketing = =>
        if isScrolledToElement(@el)
          isFeatureEnabled(featureKey)
          window.removeEventListener('scroll', @_onScrollForBottomWidget)

      @_onScrollForBottomWidget = _.debounce(@_handleBottomWidgetBucketing, 200)
      window.addEventListener('scroll', @_onScrollForBottomWidget)
